import React, {Component} from 'react'
import { Route } from 'react-router-dom'
import querystring from 'query-string'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import TeamBlogInvitation from '../components/setting/teamblog/TeamBlogInvitation';
import TeamBlogWaitingList from '../components/setting/teamblog/TeamBlogWaitingList';
import TeamBlogTitle from '../components/setting/teamblog/TeamBlogTitle';
import TeamBlogListHeader from '../components/setting/teamblog/TeamBlogListHeader';
import TeamBlogList from '../components/setting/teamblog/TeamBlogList';
import Pagination from '../components/common/Pagination';
import { parseListParams } from '../components/setting/teamblog/TeamblogListHelper';
import LoadingBox from "../components/common/LoadingBox";
import { receiveItems, searchKeyword, clearItems, filterRole, receiveWaitingMembers } from '../actions/setting/teamblog'
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import {addPrefix} from "../utils/UriUtil";


@withRouter
@connect(state => ({
    totalCount: state.teamblog.item.totalCount,
    waitingMembers : state.teamblog.item.waitingMembers,
}), (dispatch) => ({
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleReceiveWaitingMembers: (items) => {
        dispatch(receiveWaitingMembers(items))
    },
    handleSearch: (keyword) => {
        dispatch(searchKeyword(keyword))
    },
    handleRole: (role) => {
        dispatch(filterRole(role))
    },
    handleClearItems: () => {
        dispatch(clearItems())
    }
}))
class TeamBlogApp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            initialized : InitStatus.INIT_READY,
        };
        this.init = this.init.bind(this);

    }

    componentDidMount() {
        this.init();
    }

    init() {
        let listParams = parseListParams(this.props.location.search);
        const { page, role, searchKeyword } = listParams;

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/teamblog/init.json?") + querystring.stringify({
            page: page,
            role : role,
            searchKeyword: searchKeyword
        }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.members, data.totalCount);
                this.props.handleReceiveWaitingMembers(data.waitingMembers);
                this.props.handleRole(role);
                this.props.handleSearch(searchKeyword);
                this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                })
            })
            .catch(e => {
                this.props.handleReceiveItems([], 0);
                this.setState({
                    initialized: InitStatus.INIT_FAIL,
                })
            })

    }

    fetchTeamBlogs(page, role, searchKeyword) {
        fetch(addPrefix("/manage/teamblog/init.json?") + querystring.stringify({
                page: page,
                role : role,
                searchKeyword: searchKeyword
            }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.members, data.totalCount);
                this.props.handleReceiveWaitingMembers(data.waitingMembers);
                this.props.handleRole(role);
                this.props.handleSearch(searchKeyword);
            })
            .catch(e => {
                this.props.handleReceiveItems([], 0);
            })
    }

    render() {

        const { totalCount, waitingMembers} = this.props;
        const { initialized } = this.state;
        return (
				<div className="inner_article manage_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
                    { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
                    { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
                    { (initialized === InitStatus.INIT_SUCCESS ) &&
                        <div className="blog_teamblog">
                            <h3 className="tit_cont">팀블로그</h3>
                            <TeamBlogInvitation/>
                            { (waitingMembers.length > 0) && <h3 className="tit_cont">수락 대기 중인 멤버</h3>}
                            { (waitingMembers.length > 0) && <TeamBlogWaitingList waitingMembers={waitingMembers}/>}
                            <TeamBlogTitle/>
                            <Route path="/teamblog" exact={false} strict={false} component={TeamBlogListHeader}/>
                            <Route path="/teamblog" exact={false} strict={false} component={TeamBlogList}/>
                            <Pagination totalCount={totalCount} parseListParams={parseListParams}/>
                        </div>
                    }
				</div>
        )
    }
}

export default TeamBlogApp;
